import type { GraphWidgetOptions } from './types'
import { GraphWidgetView, type GraphWidgetViewState } from './GraphWidgetView'
import { useGraphApiResponse } from './useGraphApiResponse'

export function GraphWidget(props: GraphWidgetOptions) {
    const {
        apiUrl = '/api/graph',
        graphId,
        period,
        title = 'Graph',
        height,
        pollIntervalMs,
        headers,
        theme = 'auto',
        data,
    } = props

    const apiState = useGraphApiResponse({
        apiUrl,
        headers,
        period,
        pollIntervalMs,
        enabled: !data,
    })

    const viewState: GraphWidgetViewState = (() => {
        if (data) return { status: 'success', data }
        if (apiState.status === 'success') return { status: 'success', data: apiState.data }
        if (apiState.status === 'error') return { status: 'error', message: apiState.message }
        if (apiState.status === 'loading') return { status: 'loading' }
        return { status: 'idle' }
    })()

    return (
        <GraphWidgetView
            graphId={graphId}
            title={title}
            height={height}
            theme={theme}
            period={period}
            state={viewState}
        />
    )
}
